import React, { useMemo, useState } from 'react';
import { Button, DatePicker, Input, Select } from 'kenshin';
import TablePro from '@/components/TablePro';
import styles from '../styles.less';
import { createAccountColumns, STAT_TYPE_OPTIONS } from '../staticData';

/** 账号级（汇总）概览：类型筛选 + 搜索条件 + 明细表格 */
const AccountTable = ({
  type,
  onTypeChange,
  rows,
  loading,
  keyword,
  onKeywordChange,
  timeRange,
  onTimeChange,
  onSearch,
}) => {
  const [pageInfo, setPageInfo] = useState({ pageNo: 1, pageSize: 10 });
  const columns = useMemo(() => createAccountColumns(type), [type]);

  const pageRows = useMemo(() => {
    const { pageNo, pageSize } = pageInfo;
    return rows.slice((pageNo - 1) * pageSize, pageNo * pageSize);
  }, [rows, pageInfo]);

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <span className={styles.cardTitle}>
          <svg
            className={styles.cardTitleIcon}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <rect
              x="2.5"
              y="2.5"
              width="11"
              height="12"
              rx="2"
              stroke="#e0a44a"
              strokeWidth="1.4"
            />
            <path d="M6 1.5h4v2.5H6z" fill="#e0a44a" />
            <path
              d="M5.5 7h5M5.5 9.5h5M5.5 12h3"
              stroke="#e0a44a"
              strokeWidth="1.2"
              strokeLinecap="round"
            />
          </svg>
          账号级（汇总）概览
        </span>
      </div>
      <div className={styles.tableSearch}>
        <div className={styles.typeFilter}>
          <span className={styles.timeLabel}>类型</span>
          <Select
            className={styles.typeSelect}
            options={STAT_TYPE_OPTIONS}
            value={type}
            onChange={onTypeChange}
          />
        </div>
        <Input
          className={styles.searchInput}
          value={keyword}
          allowClear
          placeholder="搜索账号名称..."
          onChange={(e) => onKeywordChange(e.target.value)}
        />
        <div className={styles.timeRange}>
          <span className={styles.timeLabel}>时间区间</span>
          <DatePicker
            className={styles.timePicker}
            value={timeRange[0]}
            format="YYYY/MM/DD"
            allowClear={false}
            onChange={(date) =>
              onTimeChange([date || timeRange[0], timeRange[1]])
            }
          />
          <span className={styles.timeSplit}>至</span>
          <DatePicker
            className={styles.timePicker}
            value={timeRange[1]}
            format="YYYY/MM/DD"
            allowClear={false}
            onChange={(date) =>
              onTimeChange([timeRange[0], date || timeRange[1]])
            }
          />
        </div>
        <Button
          type="primary"
          className={styles.searchBtn}
          style={{ background: '#64748b', borderColor: '#64748b' }}
          onClick={onSearch}
        >
          查询
        </Button>
      </div>
      <TablePro
        columns={columns}
        data={{
          datas: pageRows,
          total: rows.length,
          pageSize: pageInfo.pageSize,
        }}
        loading={loading}
        isRequest={false}
        curColumns
        columnsOptions={false}
        scrollX
        scrollY={false}
        rowKey="empName"
        onChange={(pagination) =>
          setPageInfo({
            pageNo: pagination?.current || 1,
            pageSize: pagination?.pageSize || 10,
          })
        }
      />
    </div>
  );
};

export default AccountTable;
